import { BadgeVariants } from "ds/components/Badge/types";

type DoraGrade = {
  label: string;
  badgeVariant: BadgeVariants;
  color: string;
};

export type DoraGradeThresholds = {
  excellentMax: number;
  fairMax: number;
};

const GRADES: Record<string, DoraGrade> = {
  excellent: {
    label: "Excellent",
    badgeVariant: "green",
    color: "var(--semantic-color-foreground-success)",
  },
  fair: {
    label: "Fair",
    badgeVariant: "yellow",
    color: "var(--semantic-color-foreground-warning)",
  },
  needsImprovement: {
    label: "Needs improvement",
    badgeVariant: "red",
    color: "var(--semantic-color-foreground-danger)",
  },
};

export const getDoraGrade = (
  averageSeconds: number,
  thresholds: DoraGradeThresholds
): DoraGrade | undefined => {
  if (!averageSeconds) return undefined;

  if (averageSeconds <= thresholds.excellentMax) return GRADES.excellent;
  if (averageSeconds <= thresholds.fairMax) return GRADES.fair;

  return GRADES.needsImprovement;
};
